import './App.css';
import Layout from './core/components/Layout';

function App() {
  return (
    <Layout />
  );
}

export default App;
